// function to update breadcrumb
export const addCrumb = (obj) => async (dispatch) => {
  // returning payload to reducer
  return dispatch({ type: "ADD_CRUMB", payload: obj });
};
